module.exports = __webpack_public_path__ + "img/gadol_no.2f8f309b.png";